import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const prepareTOTPRegistration = actionCreator(
  actionTypes.PREPARE_TOTP_REGISTRATION
)

export const prepareTOTPRegistrationFailed = actionCreator(
  actionTypes.PREPARE_TOTP_REGISTRATION_FAILED,
  errorPayload => errorPayload
)

export const prepareTOTPRegistrationSucceeded = actionCreator(
  actionTypes.PREPARE_TOTP_REGISTRATION_SUCCEEDED
)

export const finishTOTPRegistration = actionCreator(
  actionTypes.FINISH_TOTP_REGISTRATION,
  submitDataPayload => submitDataPayload
)

export const finishTOTPRegistrationSucceeded = actionCreator(
  actionTypes.FINISH_TOTP_REGISTRATION_SUCCEEDED
)

export const finishTOTPRegistrationFailed = actionCreator(
  actionTypes.FINISH_TOTP_REGISTRATION_FAILED,
  errorPayload => errorPayload
)
